import { slateGQLFields } from '../slate/slate.fields.js';
const BASIC_CALLBACK_FIELDS = {
    slate: 'all',
};
const DEFAULT_CALLBACK_FIELDS = {
    slate: 'all',
};
export const callbackGQLFields = (fields) => {
    if (!fields || fields === 'default')
        fields = DEFAULT_CALLBACK_FIELDS;
    if (fields === 'basic')
        fields = BASIC_CALLBACK_FIELDS;
    return `
    action
    toast {
      status
      duration
      title
      description
    }
    ${fields.slate
        ? `
      slate {
        ${slateGQLFields(fields.slate)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=callback.fields.js.map